const state = {
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '月份',
        prop: 'reportTime',
        checked: 1,
        sortable: true,
      },
      {
        label: '通行费价税合计',
        prop: 'totalAmountText',
        checked: 1,
        sortable: true,
      },
      {
        label: '可抵扣税额合计',
        prop: 'totalTaxAmountText',
        checked: 1,
        sortable: true,
      },
      {
        label: '上传运单数合计',
        prop: 'waybillCountText',
        checked: 1,
        sortable: true,
      },
      {
        label: '通行交易条数',
        prop: 'payTransactionNumText',
        checked: 1,
        sortable: true,
      },
      {
        label: '消费金额合计',
        prop: 'consumeAmountText',
        checked: 1,
        sortable: true,
      },
      {
        label: '储值次数',
        prop: 'rechargeCountText',
        checked: 1,
        sortable: true,
      },
      {
        label: '储值金额（元）',
        prop: 'rechargeAmountText',
        checked: 1,
        sortable: true,
      },
    ],
    total: 0,
  },
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  // 更新data数据
  updateListData(state, payload) {
    state.listData = payload;
  },
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
